import React from 'react';

import { Heading } from '../../Common/Heading';
import { SectionContent } from './SectionContent';

export const CommonValance = () => {
  return (
    <SectionContent>
      <Heading>Common valance</Heading>
    </SectionContent>
  );
};
